import {
  fetchServices,
  storeFileRefreshment,
  storeReceipt,
  getInfoRefreshment,
  getCurrencies,
  getDataBank,
  getDataFields,
  getPricePersonRefreshment,
  checkValidatorField,
  getCountrys
} from '@/api/service'
const getRefreshment = (context) => {
  fetchServices().then((response) => {
    context.commit(
      'REFRESHMENT_UPDATED',
      _.find(response, function (o) {
        return o.service_id == 2
      })
    )
  })
}

const uploadImg = (context, data) => {
  return storeFileRefreshment(data).then((response) => {
    return response
  })
}

const saveInfoPax = (context, data) => {
  return storeReceipt(data).then((response) => {
    return response
  })
}

const getInfoRef = (context, refreshmentId) => {
  getInfoRefreshment(refreshmentId).then((response) => {
    context.commit('REFRESHMENT_INFO', response)
  })
}

const resetRefreshmentInfo = (context) => {
  context.commit('REFRESHMENT_INFO', {})
}

const getListCurrency = (context, data) => {
  getCurrencies(data).then((response) => {
    _.filter(response, function (o) {
      return o.payInAllowed
    })
    context.commit(
      'UPDATE_CURRENCIES',
      _.filter(response, function (o) {
        return o.payInAllowed
      })
    )
  })
}

const getListCountry = (context) => {
  return getCountrys().then((response) => {
    if (response) {
      context.commit('UPDATE_COUNTRYS', response)
    }
    return response
  })
}

const changeCurrency = (context, data) => {
  return getDataBank(data).then((response) => {
    if (response?.success) {
      context.commit('UPDATE_DATA_BANK', response.data)
    }
    return response
  })
}

const updateDataField = (context, data) => {
  return getDataFields(data).then((response) => {
    if (response?.success) {
      context.commit('UPDATE_DATA_BANK', response.data)
    }
  })
}

const getPriceRef = (context, refreshmentId) => {
  return getPricePersonRefreshment(refreshmentId).then((response) => {
    let dataRefreshments = _.filter(response, function (o) {
      return o.service_id == 2
    })
    context.commit('REFRESHMENT_PRICE', dataRefreshments)
    return dataRefreshments
  })
}

const checkValidator = (context, data) => {
  return checkValidatorField(data).then((response) => {
    return response
  })
}
export default {
  getRefreshment,
  uploadImg,
  saveInfoPax,
  getInfoRef,
  resetRefreshmentInfo,
  getListCurrency,
  changeCurrency,
  updateDataField,
  getPriceRef,
  checkValidator,
  getListCountry
}
